import { useState } from "react";
import {
  ConfirmationDialog,
  InformationDialog,
} from "../../components/DialogCollection";
import { connect } from "react-redux";
import { toast } from "react-toastify";
const BlockPage = (props) => {
  const { submitBlock, params, onClose } = props;
  const { creator, creatorName } = params;
  const [isOpen, setIsOpen] = useState(false);
  const processBlock = async () => {
    await submitBlock(creator).then(function (result) {
      if (result.status === 200) {
        setIsOpen(true);
      } else {
        toast.error("Kesalahan pada sistem", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
    });
  };
  return (
    <div>
      <ConfirmationDialog
        title="Block"
        message={"Do you want to block " + creatorName + " ?"}
        confirmLabel="Yes"
        cancelLabel="No"
        isCustomBtn
        style={{ width: "300px" }}
        show={true}
        onCancel={() => {
          onClose();
        }}
        onConfrim={() => {
          processBlock();
        }}
      />
      {isOpen ? (
        <InformationDialog
          title="Successful"
          style={{ width: "300px" }}
          message={"You can’t see all post/comment from " + creatorName}
          closeLabel="Done"
          show={isOpen}
          onHide={() => {
            onClose();
            window.location.reload(false);
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  submitBlock: dispatch.BlockSM.submitBlock,
});

export default connect(mapStateToProps, mapDispatchToProps)(BlockPage);
